export default "__VITE_ASSET__ckjhKFSPAdh_pUu$2yW7Fg__"